/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanfullname1m3Inputs */



/**
* | output |
* | --- |
* | "'Monster', 1 month" |
*
* @param {Monsterplanfullname1m3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanfullname1m3 = /** @type {((inputs?: Monsterplanfullname1m3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanfullname1m3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("'Monster', 1 month")
	if (locale === "es") return /** @type {LocalizedString} */ ("«Monster», 1 mes")
	return /** @type {LocalizedString} */ ("«Монстр», 1 месяц")
});
export { monsterplanfullname1m3 as "monsterPlanFullName1m" }